(function () {
  'use strict';
  var s = window.UT && window.UT.settings ? window.UT.settings : {};
  var reduce = s.reducedMotion && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initLenis() {
    if (reduce || !s.smoothScroll || typeof Lenis === 'undefined') return;
    var lenis = new Lenis({ duration: 1.15, smoothWheel: true, gestureOrientation: 'vertical' });
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    }
    window.UT.lenis = lenis;
  }

  function initReveals() {
    var els = document.querySelectorAll('.ut-reveal');
    if (!els.length) return;
    if (reduce || !s.scrollReveals) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // GSAP stagger if available
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      gsap.utils.toArray('.ut-grid').forEach(function (grid) {
        var cards = grid.querySelectorAll('.ut-reveal');
        if (!cards.length) return;
        gsap.from(cards, {
          opacity: 0,
          y: 40,
          duration: 0.8,
          stagger: 0.08,
          ease: 'power3.out',
          scrollTrigger: { trigger: grid, start: 'top 85%' }
        });
        cards.forEach(function (c) { c.classList.add('is-in'); c.style.opacity = ''; c.style.transform = ''; });
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
      els.forEach(function (el) {
        if (!el.classList.contains('is-in')) io.observe(el);
      });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  function initHeaderScroll() {
    var hdr = document.querySelector('.ut-header');
    if (!hdr) return;
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('is-scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  window.addEventListener('load', function () {
    initLenis();
    initReveals();
    initHeaderScroll();
  });
})();
